import { EyeOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Table,
  Empty,
  Button,
  Select,
  notification,
  Modal,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { exportState } from "../../../utils/exportState";
import { Dropdown } from "semantic-ui-react";
import { ModalExportacion } from "../../../components/Administrador/ModalExportacion/ModalExportacion";
import { useProyectos } from "../../../hooks/useProyectos";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalBeneficiarios } from "./modal-beneficiarios";
import { VerMasProyectos } from "./VerMasProyectos";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiDocumentos from "../../../api/Documentos/api-documentos";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import { TemplateContext } from "../../../utils/template_context";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import getStorageUser from "../../../middlewares/GetStorageUser";
import { lineasVisibles } from "../../../utils/lineasVisibles";
import {
  CHIPS_ESTADO_RESULTADO,
  CLAVE_TODAS,
  colorDeFondo,
  contarChipResultado,
  proyectosDelChip,
} from "../../../utils/chipsEstadoResultado";
import JSZip from "jszip";
import { generarPlanillaPDF, runWithConcurrency } from "./generarPlanillaPDF";

export const Proyectos = () => {
  let {
    proyectos,
    cambiarCantidadPaginas,
    cantidadPaginas,
    handleLineaChange,
    obtenerLineaConvocatoria,
    obtenerProyectos,
    lineaConvocatorias,
    loading,
    filtros,
    buscarFiltros,
  } = useProyectos();

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    obtenerLineaConvocatoria();
  }, []);

  const ref = useRef<any>();

  const TipoDocumento: any = {
    "1": "CC",
    "3": "CC",
    "2": "NIT",
  }
  // colors state of postulation
  const coloresEstado: any = {
    Aceptado: "#00904C",
    "Por evaluar": "#F28C02",
    "Evaluado": "#6435C9"
  };
  const [user, setUser] = useState<any>({});
  // Chip de estado seleccionado encima de la tabla. Empieza en Total, que no
  // filtra nada.
  const [chipActivo, setChipActivo] = useState<string>(CLAVE_TODAS);
  const [paginaActual, setPaginaActual] = useState<number>(1);

  const alternarChip = (clave: string) => {
    // Volver a tocar el chip encendido quita el filtro.
    setChipActivo((actual) => (actual === clave ? CLAVE_TODAS : clave));
    setPaginaActual(1);
  };

  // Los numeros se cuentan sobre la lista completa, no sobre lo que se esta
  // mostrando, para que al filtrar por un chip los demas no se vayan a cero.
  const proyectosMostrados = proyectosDelChip(proyectos, chipActivo);

  useEffect(() => {
    // Una busqueda nueva empieza en la primera pagina.
    setPaginaActual(1);
  }, [proyectos]);
  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
        <span style={{ whiteSpace: "pre-line" }}>
          {data?.nombre_propuesta}
        </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 80,
      render: (data: any) => <span style={{ color: coloresEstado[data?.estado] }}>{data?.estado}</span>,
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{ whiteSpace: "pre-line" }}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
          <span style={{ whiteSpace: "pre-line" }}>{datos.categoria_linea_convocatoria}</span>
        );
      },
    },
    {
      title: "Tipo de Documento",
      width: 100,
      render: (data: any) => <span>{TipoDocumento[data?.postulacion?.tipo_participante]}</span>,
    },
    {
      title: "Documento",
      width: 100,
      render: (data: any) => <span>{data?.postulacion?.numero_documento_participante}</span>,
    },
    {
      title: "Puntaje final",
      width: 100,
      whiteSpace: "nowrap",
      className: "white-space-nowrap",
      style: { whiteSpace: "nowrap" },
      render: (data: any) => <span>{data?.postulacion?.nota_final}</span>,
      fixed: context.device === "lg" ? "right" : false,
    },
    {
      title: () => (
        <Row>
          <Col span={24} className="justify-content-center">
            Ver
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <Row>
          <Col span={24} className="justify-content-center">
            <EyeOutlined
              onClick={() => verMas(datos)}
            />
          </Col>
        </Row>
      ),
    },
    /*{
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Seleccionar
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, idx: number) => (
        <>
          {datos.estado !== "Beneficiario" && (
            <Row className="width-100">
              <Col span={24} className="justify-content-center items-align-center mb-0 ">
                <Form ref={ref}>
                  <Form.Item name="select" className="mb-0 align-items-center">
                    <Checkbox
                      checked={datos.checked}
                      onChange={(e) => addProyectos(e.target.checked, datos)}
                    ></Checkbox>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          )}
        </>
      ),
    },*/
  ];

  const [verMasOpen, setVerMasOpen] = useState(false);
  const [datos, setDatos] = useState({
    nombre_propuesta: "",
    radicado: "",
    linea_convocatoria: "",
    categoria_linea_convocatoria: [{ text: "" }],
    jurados: [],
  });
  const verMas = (datos: any) => {
    setVerMasOpen(true);
    setDatos(datos);
  };

  const [proyectosBeneficiarios] = useState<any>([]);

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };

  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Proyectos Beneficiarios", value: "Beneficiario" },
    { id: 2, nombre: "Proyectos No Beneficiarios", value: "No Beneficiario" },
  ];

  const [openModal, setOpenModal] = useState(false);

  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  const [openModalBeneficiarios, setOpenModalBeneficiarios] = useState(false);
  const [loadingPlanillas, setLoadingPlanillas] = useState(false);
  const [loadingEvaluar, setLoadingEvaluar] = useState(false);

  const firmaPorJurado = async (jurado: any): Promise<string | null> => {
    if (jurado?.firma) {
      try {
        const firma = await apiDocumentos.consultarArchivo(jurado.firma);
        if (firma?.data) {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(firma.data);
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = () => resolve(null);
          });
        }
      } catch {
        return null;
      }
    }
    return null;
  };

  const descargarZip = async (zip: any, nombreArchivo: string) => {
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const procesarProyecto = async (
    proyecto: any,
    convocatoriaCache: Record<string, Promise<string>>
  ): Promise<Blob | null> => {
    const { data } = await apiParticipantes.obtenerJuradosCriterios(proyecto.id_postulacion);
    if (!data || data.length === 0) return null;

    const convocatoriaId = proyecto.postulacion?.convocatoria_id;
    if (convocatoriaId && convocatoriaCache[convocatoriaId] === undefined) {
      convocatoriaCache[convocatoriaId] = apiConvocatorias.getConvocatoriaById(convocatoriaId)
        .then(convocatoria => {
          for (const f of convocatoria.data.fechas) {
            if (f.clave === 'Informe de evaluación' && f.valormin) {
              const d = new Date(f.valormin);
              if (!isNaN(d.getTime())) {
                return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
              }
            }
          }
          return '';
        })
        .catch(() => '');
    }

    const [juradosConFirmas, informeEvaluacion] = await Promise.all([
      Promise.all(data.map(async (jurado: any) => ({ ...jurado, src: await firmaPorJurado(jurado) }))),
      convocatoriaId ? convocatoriaCache[convocatoriaId] : Promise.resolve(''),
    ]);

    return generarPlanillaPDF(proyecto, juradosConFirmas, informeEvaluacion);
  };

  const planillas = async () => {
    if (proyectos.length === 0) {
      openNotification({
        titulo: "Sin proyectos",
        descripcion: "No hay proyectos en la lista para exportar",
        placement: "bottomRight",
      });
      return;
    }

    setLoadingPlanillas(true);
    exportState.suppressRedirect = true;

    const convocatoriaCache: Record<string, Promise<string>> = {};

    try {
      notification.info({
        key: 'exportando-planillas',
        message: 'Exportando planillas',
        description: `Procesando ${proyectos.length} proyecto(s)...`,
        placement: 'bottomRight',
        duration: 0,
      });

      const zip = new JSZip();
      const omitidos: string[] = [];

      const resultados = await runWithConcurrency(
        proyectos,
        async (proyecto: any) => {
          try {
            const blob = await procesarProyecto(proyecto, convocatoriaCache);
            if (!blob) {
              omitidos.push(proyecto.radicado);
              console.warn(`[Planillas] Sin jurados: ${proyecto.radicado}`);
            }
            return blob ? { radicado: proyecto.radicado, blob } : null;
          } catch (err) {
            omitidos.push(proyecto.radicado);
            console.error(`[Planillas] Error en ${proyecto.radicado}:`, err);
            return null;
          }
        },
        2
      );

      let totalGenerados = 0;
      for (const res of resultados) {
        if (res) {
          zip.file(`${res.radicado}.pdf`, res.blob);
          totalGenerados++;
        }
      }

      if (omitidos.length > 0) {
        notification.warning({
          message: `${omitidos.length} proyecto(s) sin planilla`,
          description: `Sin jurados asignados o con error: ${omitidos.join(', ')}`,
          placement: 'bottomRight',
          duration: 12,
        });
      }

      if (totalGenerados > 0) {
        const linea = (proyectos[0]?.linea_convocatoria || 'planillas_evaluacion')
          .replace(/[/\\?%*:|"<>]/g, '-').trim();
        await descargarZip(zip, `${linea}.zip`);
      }

      notification.success({
        key: 'exportando-planillas',
        message: 'Exportación completada',
        description: `Se generaron ${totalGenerados} planilla(s)`,
        placement: 'bottomRight',
      });
    } catch (error: any) {
      console.error(error);
      notification.warning({
        key: 'exportando-planillas',
        message: 'Error al exportar',
        description: 'Ocurrió un error al iniciar la exportación. Verifica tu sesión e intenta de nuevo.',
        placement: 'bottomRight',
        duration: 8,
      });
    } finally {
      exportState.suppressRedirect = false;
      setLoadingPlanillas(false);
    }
  };

  // Evalúa una propuesta: calcula el puntaje final (líneas "SM -" suman sin dividir; el resto promedia) y lo guarda.
  const evaluarProyecto = async (proyecto: any): Promise<'evaluado' | 'omitido'> => {
    const { data } = await apiParticipantes.obtenerJuradosCriterios(proyecto.id_postulacion);
    if (!data || data.length === 0) return 'omitido';

    const esLineaSM = String(proyecto?.linea_convocatoria ?? '').includes('SM -');
    const totalNotas = data.reduce(
      (acc: number, j: any) => acc + j.criterios.reduce((ct: number, c: any) => ct + c.nota, 0),
      0
    );
    const puntajePromedio = parseFloat((esLineaSM ? totalNotas : totalNotas / data.length).toFixed(2));

    await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: proyecto.id_postulacion, estado: 'Evaluado' });
    await apiParticipantes.notaFinalPostulacion({ id_postulacion: proyecto.id_postulacion, puntajePromedio });
    return 'evaluado';
  };

  const ejecutarEvaluarTodas = async (pendientes: any[]) => {
    setLoadingEvaluar(true);
    exportState.suppressRedirect = true;
    try {
      notification.info({
        key: 'evaluando-todas',
        message: 'Evaluando proyectos',
        description: `Procesando ${pendientes.length} proyecto(s)...`,
        placement: 'bottomRight',
        duration: 0,
      });

      const resultados = await runWithConcurrency(
        pendientes,
        async (proyecto: any) => {
          try {
            return await evaluarProyecto(proyecto);
          } catch (err) {
            console.error(`[Evaluar] Error en ${proyecto.radicado}:`, err);
            return 'error' as const;
          }
        },
        3
      );

      const evaluados = resultados.filter((r) => r === 'evaluado').length;
      const omitidos = pendientes.filter((_, i) => resultados[i] !== 'evaluado').map((p) => p.radicado);

      if (omitidos.length > 0) {
        notification.warning({
          message: `${omitidos.length} proyecto(s) sin evaluar`,
          description: `Sin jurados asignados o con error: ${omitidos.join(', ')}`,
          placement: 'bottomRight',
          duration: 12,
        });
      }

      notification.success({
        key: 'evaluando-todas',
        message: 'Evaluación completada',
        description: `Se evaluaron ${evaluados} proyecto(s)`,
        placement: 'bottomRight',
        duration: 10,
      });

      await buscarFiltros();
    } catch (error) {
      console.error(error);
      notification.warning({
        key: 'evaluando-todas',
        message: 'Error al evaluar',
        description: 'Ocurrió un error durante la evaluación masiva. Verifica tu sesión e intenta de nuevo.',
        placement: 'bottomRight',
        duration: 8,
      });
    } finally {
      exportState.suppressRedirect = false;
      setLoadingEvaluar(false);
    }
  };

  const evaluarTodas = () => {
    const pendientes = proyectos.filter((p: any) => p.estado === 'Por evaluar');
    if (pendientes.length === 0) {
      openNotification({
        titulo: 'Sin proyectos por evaluar',
        descripcion: 'No hay proyectos en estado "Por evaluar" en el listado actual.',
        placement: 'bottomRight',
      });
      return;
    }
    Modal.confirm({
      title: 'Evaluar toda la línea',
      content: `Se marcarán como "Evaluado" y se guardará el puntaje final de los ${pendientes.length} proyecto(s) en estado "Por evaluar" del listado actual. Esta acción es visible para los participantes. ¿Deseas continuar?`,
      okText: 'Sí, evaluar todas',
      cancelText: 'Cancelar',
      onOk: () => ejecutarEvaluarTodas(pendientes),
    });
  };

  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Resultado evaluación" },
  ];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Resultado de evaluación
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Buscar{" "}
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="row mb-3">
                  <div className="col-12 pb-2 ">
                    <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B pb-2">Filtrar línea convocatoria</span>
                  </div>
                  <div>
                    <Select
                      showSearch
                      optionFilterProp="children"
                      suffixIcon={<FlechaSelect />}
                      value={filtros.linea_convocatoria}
                      size="large"
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                      onChange={handleLineaChange}
                    >
                      {lineasVisibles(lineaConvocatorias, user.documento).map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={id}>{nombre}</Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-blanco-radius m-0"
                onClick={buscarFiltros}
                disabled={loading}
              >
                Buscar
              </Button>
            </div>
          </div>
        </div>

        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div className="my-scrollable-div col-12 col-md-12 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
                {CHIPS_ESTADO_RESULTADO.map((chip) => {
                  const activo = chipActivo === chip.clave;
                  return (
                    <button
                      key={chip.clave}
                      type="button"
                      aria-pressed={activo}
                      title={
                        chip.estados === null
                          ? "Mostrar todos los proyectos"
                          : `Mostrar solo: ${chip.etiqueta}`
                      }
                      onClick={() => alternarChip(chip.clave)}
                      className={`d-flex justify-content-end mx-2 ${chip.clase}`}
                      style={{
                        flexShrink: 0,
                        font: "inherit",
                        color: "inherit",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        borderRadius: 16,
                        padding: "2px 10px",
                        border: `1px solid ${chip.color}`,
                        background: activo ? colorDeFondo(chip.color) : "transparent",
                        fontWeight: activo ? 600 : "normal",
                      }}
                    >
                      {chip.etiqueta} :{" "}
                      <span className={chip.claseNumero}>
                        &nbsp;{contarChipResultado(proyectos, chip.clave)}
                      </span>
                    </button>
                  );
                })}
                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <span className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </span>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPaginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg />
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadPaginas,
                    current: paginaActual,
                    onChange: (pagina: number) => setPaginaActual(pagina),
                  }}
                  dataSource={proyectosMostrados}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer justify-content-flex-end">
        <div className="justify-este content-flex-end">
        </div>
        <div className="justify-content-end">
          {(user.role_id == 1 || user.role_id == 2) && (
            <Button className="button-azul-radius ms-1" onClick={evaluarTodas} loading={loadingEvaluar} disabled={loadingEvaluar || loadingPlanillas}>
              Evaluar todas
            </Button>
          )}
          <Button className="button-azul-radius ms-1" onClick={planillas} loading={loadingPlanillas} disabled={loadingPlanillas || loadingEvaluar}>
            Exportar planillas
          </Button>
        </div>
      </div>

      {openModal && (
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Postulaciones"
          consulta="1"
        />
      )}

      {openModalBeneficiarios && (
        <ModalBeneficiarios
          openModal={openModalBeneficiarios}
          proyectosBeneficiarios={proyectosBeneficiarios.filter(
            (x: any) => x.checked === true
          )}
          setOpenModal={setOpenModalBeneficiarios}
          obtenerProyectos={obtenerProyectos}
          referencia={ref}
        />
      )}

      {verMasOpen && (
        <VerMasProyectos
          openModal={verMasOpen}
          setOpenModal={setVerMasOpen}
          datos={datos}
        />
      )}
    </div>
  );
};
